module.exports = __webpack_public_path__ + "static/media/money-check-edit-alt.aaa34d35.svg";